import React from 'react';
import { object, string } from 'yup';
import omit from 'lodash/omit';
import startCase from 'lodash/startCase';

import { useTranslation } from 'react-i18next';
import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const schema = object().shape({
  email: string().email().required(),
});
const defaults = {
  active: true,
  email: '',
  password: '',
  name: { full: { en: '', zhhk: '' } },
  open: {
    category: '',
    school: '',
    SchoolClass: '',
    studentId: '',
  },
};

const FormOpen = ({
  open,
}) => {
  const { t } = useTranslation();
  return (
  <FormResource
    {...{
      defaults,
      schema,
      stored: open,
      api: '/api/core/users/opens',
      onSubmit: (v) => omit(v, !v.password ? 'password' : null),
    }}
  >
    <div className="form-group">
      <label>{t('Active')}</label>
      <FormCheckGroup
        name="active"
        type="checkbox"
        label=""
        asSwitch
      />
    </div>
    <FormGroup name="email" label={t('Email')} />
    <FormGroup
      name="password"
      label={t('Password')}
      type="password"
      placeholder={
        open ? t('Leave this blank to keep the stored password') : ''
      }
    />
    <div className="form-row">
      <div className="col">
        <FormGroup name="name.full.zhhk" label={t('Name (Chinese)')} />
      </div>
      <div className="col">
        <FormGroup name="name.full.en" label={t('Name (English)')} />
      </div>
    </div>
    <FormGroup
      name="open.category"
      label={t('Identity')}
      as="select"
    >
      {
        ['teacher', 'student', 'parent', 'public'].map((key) => (
          <option
            value={key}
            key={key}
          >
            {(startCase(key))}
          </option>
        ))
      }
    </FormGroup>
    <div className="form-row">
      <div className="col">
        <FormGroup name="open.school" label={t('School')} />
      </div>
      <div className="col">
        <FormGroup name="open.schoolClass" label={t('Class')} />
      </div>
      <div className="col">
        <FormGroup name="open.studentId" label={t('Class No.')} />
      </div>
    </div>
  </FormResource>
  );
};

export default FormOpen;
